import { useState, useCallback, useEffect } from 'react';
import { getRelatorioPorTipoDeCompra } from '../services/reportApi';
import type { ReportPricingModelResponse } from '../types';

export interface UseReportPricingModelResult {
    data: ReportPricingModelResponse | null;
    loading: boolean;
    error: Error | null;
    refresh: () => Promise<void>;
}

/**
 * Hook para carregar e atualizar os dados de relatório por tipo de compra (CPM/CPV/CPC).
 * Usado pela página de Report e pelos cards de resumo.
 */
export function useReportPricingModel(campaignId: string | undefined): UseReportPricingModelResult {
    const [data, setData] = useState<ReportPricingModelResponse | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const refresh = useCallback(async () => {
        if (!campaignId) {
            setData(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const result = await getRelatorioPorTipoDeCompra(parseInt(campaignId, 10));
            setData(result as ReportPricingModelResponse);
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
            setData(null);
        } finally {
            setLoading(false);
        }
    }, [campaignId]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return { data, loading, error, refresh };
}
